import config from "../config/settings";
import { createRequest } from "urql";
import { client as client0 } from "../support/graphqlApi";
import { subscribeOnStream, unsubscribeFromStream } from "./chartStreams";
import { getOptimalDecimals } from "../utils/number";

const isDevelopment = config.isDevelopment;
const configurationData = {
  supported_resolutions: [
    "1S",
    "5S",
    "30S",
    "1",
    "3",
    "5",
    "10",
    "15",
    "30",
    "45",
    "60",
    "120",
    "180",
    "240",
    "360",
    "720",
    "1D",
    "2D",
    "3D",
    "1W",
    "2W",
    "3W",
  ],
  has_seconds: true,
  seconds_multipliers: ["1"],
  supports_group_request: false,
  supports_marks: false,
  supports_search: false,
  supports_timescale_marks: false,
  has_intraday: true,
  enabled_features: ["seconds_resolution"],
};
const lastBarsCache = new Map();
const client = client0();

const DataFeed = (pairAddress, initialPrice, isUSD) => ({
  onReady: (callback) => {
    if (isDevelopment) console.log("[onReady]: Method call");
    setTimeout(() => callback(configurationData));
  },

  resolveSymbol: async (
    pair,
    onSymbolResolvedCallback,
    onResolveErrorCallback
  ) => {
    try {
      if (isDevelopment) console.log("[resolveSymbol]: Method call", pair);
      console.log("Initial price received:", initialPrice);

      var symbolInfo = {
        symbol: pairAddress,
        name: "ETHUSDC",
        //exchange: "UNI V3",
        session: "24x7",
        pricescale: (() => {
          try {
            let decimals = getOptimalDecimals(initialPrice, 0.01);

            const scale = Math.pow(10, Math.max(1, Math.min(decimals, 18))); // At least 1 decimal, max 8
            return scale;
          } catch (err) {
            return 1000000000000000000; // Fallback to 8 decimals
          }
        })(),
        minmov: 1,
        type: "crypto",
        has_intraday: true,
        has_daily: true,
        has_weekly_and_monthly: false,
        has_empty_bars: false,
        has_no_volume: false,
        volume_precision: isUSD ? 2 : 4,
        data_status: "streaming",
        timezone: "Etc/UTC",
        has_seconds: true,
        seconds_multipliers: ["1"],
        supported_resolutions: [
          "1S",
          "5S",
          "30S",
          "1",
          "3",
          "5",
          "10",
          "15",
          "30",
          "45",
          "60",
          "120",
          "180",
          "240",
          "d",
          "2d",
          "3d",
          "1w",
          "2w",
        ],
      };

      console.log("Full symbol info:", symbolInfo);

      setTimeout(() => onSymbolResolvedCallback(symbolInfo));
    } catch (error) {
      onResolveErrorCallback(error);
    }
  },

  getBars: async (
    symbolInfo,
    resolution,
    periodParams,
    onHistoryCallback,
    onErrorCallback
  ) => {
    const { from: fromT, to: toT, firstDataRequest } = periodParams;
    let from = fromT * 1000;
    let to = toT * 1000;

    if (isDevelopment)
      console.log("[getBars]: Method call", symbolInfo, resolution, from, to);

    const req = client.createRequestOperation(
      "query",
      createRequest(
        `
      query($input: CandlesInput!) {
            candles(input: $input) {
              open
              high
              low
              close
              volumeBase
              timestamp
            }
        }
      `,
        { input: { pair: symbolInfo.symbol, from, to, resolution } }
      )
    );

    try {
      let res = await client
        .executeQuery(req)
        .toPromise()
        .catch((err) => console.error(err));

      if (!res.data?.candles?.length) {
        onHistoryCallback([], {
          noData: true,
        });
        return;
      }

      const formatFloats = (num) => num; //toPrecision(7);
      var bars = [];
      res.data.candles.forEach((bar) => {
        // if (bar.timestamp >= from && bar.timestamp < to) {
        bars = [
          ...bars,
          {
            time: bar.timestamp,
            low: formatFloats(bar.low),
            high: formatFloats(bar.high),
            open: formatFloats(bar.open),
            close: formatFloats(bar.close),
            volume: formatFloats(bar.volumeBase),
          },
        ];
        // }
      });

      if (firstDataRequest) {
        lastBarsCache.set(symbolInfo.pair, bars[bars.length - 1]);
      }

      if (isDevelopment)
        console.log(`[getBars]: returned ${bars.length} bar(s)`);
      onHistoryCallback(bars, { noData: false });
    } catch (error) {
      if (isDevelopment) console.log("[getBars]: Get error", error);
      onErrorCallback(error);
    }
  },

  subscribeBars: (
    symbolInfo,
    resolution,
    onRealtimeCallback,
    subscribeUID,
    onResetCacheNeededCallback
  ) => {
    if (isDevelopment)
      console.log(
        "[subscribeBars]: Method call with subscribeUID:",
        subscribeUID
      );
    subscribeOnStream(
      symbolInfo,
      resolution,
      onRealtimeCallback,
      subscribeUID,
      onResetCacheNeededCallback,
      lastBarsCache.get(symbolInfo.pair)
    );
  },

  unsubscribeBars: (subscriberUID) => {
    if (isDevelopment)
      console.log(
        "[unsubscribeBars]: Method call with subscriberUID:",
        subscriberUID
      );
    unsubscribeFromStream(subscriberUID);
  },
});

export default DataFeed;
